// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class BestBetsPlugin {
   static initClass() {
      // @ts-expect-error TS(2339) FIXME: Property 'states' does not exist on type 'BestBets... Remove this comment to see the full error message
      this.prototype.states = ['new']
   }
   invoke(data: any, feed: any) {
      const bestBets = data.search.recommendations.best_bets
      if (bestBets && bestBets.length) {
      // take first best bet
         const item = {
            bet: bestBets[0],
            type: 'bestBet',
            hidden: false
         }
         return feed.addPositionalItem(item, 1)
      }
   }
}
BestBetsPlugin.initClass()

angular.module('summonApp.resultsFeedPlugins')
   .service('bestBetsPlugin', BestBetsPlugin)
